export default __webpack_public_path__ + "static/media/SalesIntel_2023_V2.a64b4881.pdf";